import * as types from '../actions';

export default function(state = [], action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 

    switch(action.type) {

        case types.TIMEZONES_LIST_SUCCESS:
            if(response.status===200){
                return {
                    timezonesList: response.data,
                    timezonesListStatus: response.status,  
                    timezonesListActivity:types.TIMEZONES_LIST_SUCCESS+timeVar,     
                };
            }
            else {
                return {
                    timezonesListStatus: (response.status)?response.status:0,  
                    timezonesListActivity:types.TIMEZONES_LIST_ERROR+timeVar, 
                    timezonesListErrorData:(response.data)?response.data:[]                             
                };
            }
        
        case types.TIMEZONES_LIST_ERROR:
            return {
                timezonesListStatus: (response.status)?response.status:0,
                timezonesListActivity:types.TIMEZONES_LIST_ERROR+timeVar, 
                timezonesListErrorData:(response.data)?response.data:[]                      
            };
        
        default:
            return state;
    
        }
    }